import {QueryCommand} from "xmgoing-server";

/**
 * 提交数据 并发起流程
 * @param params
 * @param backFun
 * 业务参数放在params的variables里面
 */
export const executeStartFlowFun = function (params, backFun) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/startFlow`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    backFun && backFun(des);
  });
}



/**
 * 执行提交操作
 * @param params
 * @param backFun
 */
export const executeSubmitFun = function ({params, backFun}) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/submitByBusIds`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    if (des) {
      backFun && backFun(des);
    }
  });
}


/**
 * 根据流程id进行退回操作
 * @param params
 * @param backFun
 */
export const executeBackByFlowIdFun = function ({params, backFun}) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/backFlowByFlowIds`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    if (des) {
      backFun && backFun(des);
    }
  });
}
/**
 * 根据业务记录进行退回操作
 * @param params
 * @param backFun
 */
export const executeBackFunByBusId=function ({params,backFun}){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/backFlowByBusId`,
  });
  queryCommand.executeQueryPromise({ params }).then((des) => {
    if (des) {
      backFun&&backFun();
    }
  });
}

/**
 * 根据流程id执行提交操作
 * @param params
 * @param backFun
 */
export const executeSubmitByFlowIdFun = function ({params, backFun}) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/submitByFlowIds`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    if (des) {
      backFun && backFun(des);
    }
  });
}
